// Generated with util/create-component.js
import Form from './Form';

export default Form;
